import EchartsTool from './echartsTool.js'

/**
 * 带折线
 * 
 * 胶囊图
 * 
 * 呼吸率变快
 */

import * as echarts from 'echarts';

export default function getEchartsOptionFloatA5(xAxis_data, series_data, expansion_data, markArea_range, isDifferentColors, deviateFlags, selectIndex) {
	
	// pieces
	let pieces = EchartsTool.get_line_visual_map_pieces_0_0( xAxis_data, deviateFlags, selectIndex);
	let pieces1 = EchartsTool.get_line_visual_map_pieces_0_1( xAxis_data, deviateFlags, selectIndex);

	// 辅助柱状图 series_data
	let auxiliary_series_data = [];
	let tempMax = 0;
	if (series_data && series_data.length == 3) {
		for (let i = 0; i < series_data[0].data.length; i++) {
			let item1 = parseFloat(series_data[0].data[i]);
			let item2 = series_data[1].data[i];
			let item3 = series_data[1].data[i];
			if (item1 && item1 != '-' && item2 && item2 != '-' && item3 && item3 != '-') {
				if (tempMax < item1 + item2) {
					tempMax = item1 + item2;
				}
			}
		}
	}
	if (xAxis_data && xAxis_data.length > 0) {
		for (let i = 0; i < xAxis_data.length; i++) {
			auxiliary_series_data.push(tempMax);
		}
	}

	// 选中柱子 & 未选中柱子颜色处理
	let bar_series_data_select = [];
	let bar_series_data_un_select = [];
	if (series_data && series_data.length == 3 && series_data[1].data && series_data[1].data.length > 0) {
		for (let i = 0; i < series_data[1].data.length; i++) {
			let item = series_data[1].data[i];
			if (item && item != '-') {
				bar_series_data_select.push(
					{
						value: item,
						itemStyle: {
							normal: {
								color: selectIndex == i ? (deviateFlags[i] == 1 ? 'rgba(255, 113, 134, 1)' : (deviateFlags[i] == 2 ? 'rgba(197, 212, 246, 1)' : '#FFFFFF00'))  : '#FFFFFF00'
							},
							emphasis: {
								color: selectIndex == i ? (deviateFlags[i] == 1 ? 'rgba(255, 113, 134, 1)' : (deviateFlags[i] == 2 ? 'rgba(197, 212, 246, 1)' : '#FFFFFF00'))  : '#FFFFFF00'
							}
						}
					}
				);
				bar_series_data_un_select.push(
					{
						value: item,
						itemStyle: {
							normal: {
								color: selectIndex == i ? '#FFFFFF00' : (i != series_data[1].data.length - 1 ? (deviateFlags[i] == 1 ? 'rgba(255, 113, 134, 0.1)' : 'rgba(74, 124, 232, 0.1)') : (deviateFlags[i] == 1 ? 'rgba(255, 113, 134, 1)' : 'rgba(74, 124, 232, 0.1)'))
							},
							emphasis: {
								color: selectIndex == i ? '#FFFFFF00' : (i != series_data[1].data.length - 1 ? (deviateFlags[i] == 1 ? 'rgba(255, 113, 134, 0.2)' : 'rgba(74, 124, 232, 0.2)') : (deviateFlags[i] == 1 ? 'rgba(255, 113, 134, 1)' : 'rgba(74, 124, 232, 0.2)'))
							}
						}
					}
				);
			} else {
				bar_series_data_select.push(null);
				bar_series_data_un_select.push(null)
			}
		}
	}
	

	// option
	let option = {
		grid: [
			{
				x: 23,
				y: 5,
				x2: 0,
				y2: 13,
				containLabel: false
			},
			{
				x: 23,
				y: 5,
				x2: 0,
				y2: 13,
				containLabel: false
			},
			{
				x: 23,
				y: 5,
				x2: 0,
				y2: 13,
				containLabel: false
			}
		],
		tooltip: {
			trigger: "axis",
			backgroundColor: "rgba(255, 255, 255, 1)",
			borderColor: "rgba(24, 144, 255, 0.6)",
			borderWidth: 1,
			spanStyle: {
				color: "#fff",
			},
			trigger: "axis",
			confine: true,
			borderRadius: 5,
			textStyle: {
				color: '#8394B9',
				fontSize: 14
			},
			formatter: function (params) {
				return null
			}
		},
		xAxis: [
			{
				gridIndex: 0,
				type: "category",
				data: xAxis_data,
				axisLine: {
					lineStyle: {
						color: "rgba(144, 148, 166, 0.1)"
					}
				},
				axisLabel: {
					show: false,
					textStyle: {
						color: "rgba(165, 169, 188, 1)", //坐标的字体颜色
						fontSize: 10
					},
				},
				axisTick: {
					show: false,
					alignWithLabel: true,
				},
				show: false
			},
			{
				gridIndex: 1,
				type: "category",
				data: xAxis_data,
				axisLine: {
					lineStyle: {
						color: "rgba(144, 148, 166, 0.1)"
					}
				},
				axisLabel: {
					show: false,
					textStyle: {
						color: "rgba(165, 169, 188, 1)", //坐标的字体颜色
						fontSize: 10
					},
				},
				axisTick: {
					show: false,
					alignWithLabel: true,
				},
				show: false,
			},
			{
				gridIndex: 2,
				type: "category",
				data: xAxis_data,
				axisLine: {
					lineStyle: {
						color: "rgba(144, 148, 166, 0.1)"
					}
				},
				axisLabel: {
					show: false,
					textStyle: {
						color: "rgba(165, 169, 188, 1)", //坐标的字体颜色
						fontSize: 10
					},
				},
				axisTick: {
					show: false,
					alignWithLabel: true,
				},
				show: false,
			}
		],
		yAxis: [
			{
				gridIndex: 0,
				type: "value",
				splitLine: {
					show: true
				},
				axisLine: {
					lineStyle: {
						color: "#c7c6c9"
					},
					show: false
				},
				axisLabel: {
					textStyle: {
						color: "rgba(165, 169, 188, 1)", //坐标的字体颜色
						fontSize: 10
					}
				},
				splitNumber: 2,
			},
			{
				gridIndex: 1,
				type: "value",
				splitLine: {
					show: true
				},
				axisLine: {
					lineStyle: {
						color: "#c7c6c9"
					},
					show: false
				},
				axisLabel: {
					textStyle: {
						color: "rgba(165, 169, 188, 1)", //坐标的字体颜色
						fontSize: 10
					}
				},
				splitNumber: 2,
			},
			{
				gridIndex: 2,
				type: "value",
				splitLine: {
					show: true
				},
				axisLine: {
					lineStyle: {
						color: "#c7c6c9"
					},
					show: false
				},
				axisLabel: {
					textStyle: {
						color: "rgba(165, 169, 188, 1)", //坐标的字体颜色
						fontSize: 10
					}
				},
				splitNumber: 2,
			}
		],
		visualMap: [
			{
				show: false,
				dimension: 0,
				seriesIndex: 4,
				pieces: pieces
			},
			{
				show: false,
				dimension: 0,
				seriesIndex: 8,
				pieces: pieces1
			}
		],
		series: [
			// 辅助点击柱子
			{
				xAxisIndex: 0,
				yAxisIndex: 0,
				type: "bar",
				data: auxiliary_series_data,
				barWidth: '100%',
				zlevel: 0,
				itemStyle: {
					normal: {
						color: '#FFFFFF00'
					}
				}
			},



			// 堆叠柱状图未选中1
			{
				xAxisIndex: 1,
				yAxisIndex: 1,
				zlevel: 1,
				type: "bar",
				stack: "float",
				data: series_data[0].data,
				barWidth: 6,
				itemStyle: {
					color: "#FFFFFF00"
				}
			},
			// 堆叠柱状图未选中2
			{
				xAxisIndex: 1,
				yAxisIndex: 1,
				zlevel: 1,
				type: "bar",
				stack: "float",
				data: bar_series_data_un_select,
				barWidth: 6,
				itemStyle: {
					normal: {
						barBorderRadius: [4, 4, 4, 4],
						barBorderColor: "rgba(0,0,0,0)",
					},
				}
			},
			// 堆叠柱状图未选中3
			{
				xAxisIndex: 1,
				yAxisIndex: 1,
				zlevel: 1,
				type: "bar",
				stack: "float",
				data: [],
				barWidth: 6,
				itemStyle: {
					color: "#FFFFFF00"
				}
			},
			// 折线图未选中
			{
				xAxisIndex: 1,
				yAxisIndex: 1,
				z: 5,
				data: series_data[2].data,
				type: 'line',
				symbol: 'circle',
				symbolSize: 8,
				color: 'rgba(74, 124, 232, 1)',
				itemStyle: {
					normal: {
						borderWidth: 1.5,
						borderColor: '#FCFCFD'
					},

				},
				zlevel: 1,
				emphasis: {
					scale: 1.5
				}
			},


			// 堆叠柱状图选中1
			{
				xAxisIndex: 2,
				yAxisIndex: 2,
				zlevel: 1,
				type: "bar",
				stack: "select",
				data: series_data[0].data,
				barWidth: 14,
				itemStyle: {
					color: "#FFFFFF00"
				}
			},
			// 堆叠柱状图选中2
			{
				xAxisIndex: 2,
				yAxisIndex: 2,
				zlevel: 1,
				type: "bar",
				stack: "select",
				data: bar_series_data_select,
				barWidth: 14,
				itemStyle: {
					normal: {
						barBorderRadius: [4, 4, 4, 4],
						barBorderColor: "rgba(0,0,0,0)",
					}
				}
			},
			// 堆叠柱状图选中3
			{
				xAxisIndex: 2,
				yAxisIndex: 2,
				zlevel: 1,
				type: "bar",
				stack: "select",
				data: [],
				barWidth: 14,
				itemStyle: {
					color: "#FFFFFF00"
				}
			},
			
			// 折线图选中
			{
				xAxisIndex: 2,
				yAxisIndex: 2,
				z: 5,
				data: series_data[2].data,
				type: 'line',
				symbol: 'circle',
				symbolSize: 10,
				lineStyle: {
					color: '#FFFFFF00'
				},
				zlevel: 2,
				emphasis: {
					scale: 1.5
				}
			}

		],
	};
	
	return option;
}